<template>
  <loadMore
    :endpoint="suggestedNewsroomsEndpoint"
    :fetching-text="$t('pages.dashboard.fetching_suggested_companies')"
  >
    <template #list="{ items, hydrated }">
      <div
        v-if="items.length"
        class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-7"
      >
        <newsroomCard
          v-for="newsroom in items"
          :key="newsroom.id"
          :newsroom="newsroom"
        />
      </div>
      <p
        v-else-if="hydrated"
        class="py-16 text-center font-display text-sm uppercase tracking-widest text-muted-faint"
      >
        {{ $t('pages.dashboard.no_suggested_companies_found') }}
      </p>
    </template>

    <template #loadMore="{ load, hasMore, isLoading }">
      <div v-if="hasMore" class="mt-12 flex justify-center">
        <button
          :disabled="isLoading"
          type="button"
          class="cursor-pointer rounded-full border-none bg-accent px-[30px] py-3.5 text-sm font-bold text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
          @click="load"
        >
          {{ $t('general.load_more') }}
        </button>
      </div>
    </template>
  </loadMore>
</template>
<script>
import NewsroomCard from '@/components/core/NewsroomCard'

export default {
  components: {
    NewsroomCard
  },
  data () {
    return {
      suggestedNewsroomsEndpoint: 'user/suggested/newsrooms?include=country'
    }
  }
}
</script>
